import type { Work, WorkType } from "@/types";

export const typeLabelMap: Record<WorkType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const typeDescMap: Record<WorkType, string> = {
  movie: "聚焦最新国产原创电影，院线新作、独立佳作与获奖影片持续更新。",
  tv: "年代、都市、悬疑、古装一网打尽，热播国产自制剧集每周上新。",
  variety: "真人秀、音乐竞演、美食纪实，用综艺把快乐与治愈带给你。",
};

export function typeLabel(type: WorkType): string {
  return typeLabelMap[type] ?? "影视";
}

export function typePath(type: WorkType): string {
  return `/category/${type}`;
}

export function isValidType(value: string | undefined): value is WorkType {
  return value === "movie" || value === "tv" || value === "variety";
}

export type SortKey = "latest" | "popular" | "rating";

export function sortWorks(list: Work[], sortBy: SortKey): Work[] {
  const copy = [...list];
  if (sortBy === "popular") {
    return copy.sort((a, b) => b.popularity - a.popularity);
  }
  if (sortBy === "rating") {
    return copy.sort((a, b) => b.rating - a.rating);
  }
  return copy.sort(
    (a, b) => new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime()
  );
}

export function getRelatedWorks(work: Work, all: Work[], limit = 4): Work[] {
  const sameType = all.filter((item) => item.id !== work.id && item.type === work.type);
  const sameDirector = sameType.filter((item) => item.director === work.director);
  const rest = sameType.filter((item) => item.director !== work.director);
  return [...sameDirector, ...rest].slice(0, limit);
}

export function filterByKeyword(list: Work[], keyword: string): Work[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return list;
  return list.filter((item) =>
    [
      item.title,
      item.genre,
      item.director,
      item.region,
      item.summary,
      item.tags.join(" "),
      item.cast.join(" "),
    ]
      .join(" ")
      .toLowerCase()
      .includes(key)
  );
}